import type { ReactElement } from 'react';

import BulkTrimCardReport from './bulk-trim-card';
import ProductionMonthlyOutputReport from './production-monthly-output';
import SecondOperationReport from './second-operation';
import SewingHourlyBoardReport from './sewing-hourly-board';
import SewingEfficiencyReport from './sewing-efficiency';
import SewingFactoryBoardReport from './sewing-factory-board';
import SewingFloorBoardReport from './sewing-floor-board';
import SpreadingReport from './spreading';
import T2BusinessDashboardReport from './t2-business-dashboard';
import T2BusinessReport from './t2-business';

/**
 * Report id → the element that renders it. The id is also the URL segment, the API path variable,
 * the `winsight-server` folder name and the `lib/menu.ts` `reportId` — one value, so a report cannot
 * half-exist under two names.
 *
 * Elements, not component references: resolving a component during render is what "Cannot create
 * components during render" objects to. A plain list on purpose — a config-driven page engine is the
 * semantic layer by another name (§7).
 */
export interface ReportRoute {
  reportId: string;
  element: ReactElement;
}

export const REPORT_ROUTES: readonly ReportRoute[] = [
  { reportId: 'bulk-trim-card', element: <BulkTrimCardReport /> },
  { reportId: 'sewing-hourly-board', element: <SewingHourlyBoardReport /> },
  { reportId: 'production-monthly-output', element: <ProductionMonthlyOutputReport /> },
  { reportId: 'sewing-efficiency', element: <SewingEfficiencyReport /> },
  { reportId: 'sewing-factory-board', element: <SewingFactoryBoardReport /> },
  { reportId: 'sewing-floor-board', element: <SewingFloorBoardReport /> },
  { reportId: 'second-operation', element: <SecondOperationReport /> },
  { reportId: 'spreading', element: <SpreadingReport /> },
  { reportId: 't2-business', element: <T2BusinessReport /> },
  { reportId: 't2-business-dashboard', element: <T2BusinessDashboardReport /> },
];
